import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { TrendingUp } from 'lucide-react';
import { useNetworkingAnalytics } from '@/hooks/useNetworkingAnalytics';

export const TrendingSkillsWidget = () => {
  const { trendingTopics, loading } = useNetworkingAnalytics();
  
  console.log('🔥 TrendingSkillsWidget - Topics:', trendingTopics);
  console.log('🔥 TrendingSkillsWidget - Loading:', loading);

  if (loading) {
    return (
      <Card>
        <CardContent className="py-8">
          <div className="flex items-center justify-center">
            <div className="animate-pulse">Chargement...</div>
          </div>
        </CardContent>
      </Card>
    );
  }

  const topics = trendingTopics.map(t => t.topic);

  if (topics.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <TrendingUp className="h-5 w-5 text-primary" />
          <CardTitle>Compétences les plus recherchées</CardTitle>
        </div>
        <CardDescription>
          Les compétences et secteurs tendances dans le réseau
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-2">
          {topics.slice(0, 8).map((topic, index) => (
            <Badge 
              key={index} 
              variant="secondary"
              className="text-sm"
            >
              {topic}
            </Badge>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
